import React from 'react';
import styled from 'styled-components';
import colors from 'common/styles/colors';

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px 4px ${props => 8 + props.$depth * 12}px;
  border-radius: 4px;
  cursor: default;
  font-size: 13px;
  color: ${colors.black};
  background: ${props => (props.$selected ? 'rgba(78, 137, 244, 0.12)' : 'transparent')};
  border-left: ${props => (props.$selected ? `3px solid ${colors.blue}` : '3px solid transparent')};
  &:hover {
    background: ${props => (props.$selected ? 'rgba(78, 137, 244, 0.14)' : colors.greyXL)};
  }
`;

const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-left: 8px;
  background: ${props => props.$color || colors.greyD};
`;

function conditionColor(condition) {
  if (condition === 1 || condition === '1' || condition === 'good') return colors.green;
  if (condition === 2 || condition === '2' || condition === 'warning') return colors.warning;
  if (condition === 3 || condition === '3' || condition === 'critical') return colors.critical;
  return colors.greyD;
}

function TreeRows({ nodes, depth, selectedMachineId, parentPath }) {
  if (!nodes || !nodes.length) return null;
  return nodes.map((node) => {
    const isMachine = node.node_type === 'machine';
    const selected = isMachine && String(node.id) === String(selectedMachineId);
    const path = [...parentPath, node.node_name].filter(Boolean);
    const hasChildren = node.children && node.children.length > 0;
    return (
      <React.Fragment key={`${node.node_type}-${node.id}`}>
        <Row
          $depth={depth}
          $selected={selected}
          title={path.join(' / ')}
          role="treeitem"
          aria-selected={selected}
          aria-level={depth + 1}
          aria-expanded={hasChildren ? true : undefined}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
            }
          }}
        >
          <span>{node.node_name || '—'}</span>
          <Dot $color={conditionColor(node.condition)} />
        </Row>
        {hasChildren && (
          <TreeRows
            nodes={node.children}
            depth={depth + 1}
            selectedMachineId={selectedMachineId}
            parentPath={path}
          />
        )}
      </React.Fragment>
    );
  });
}

export default function AssetHierarchyPanel({ hierarchy, machineId }) {
  const nodes = hierarchy && hierarchy.length ? hierarchy : [];
  return (
    <div role="tree" aria-label="Asset hierarchy">
      <TreeRows nodes={nodes} depth={0} selectedMachineId={machineId} parentPath={[]} />
    </div>
  );
}
